import { render, staticRenderFns } from "./AssignmentHistoryGrid.vue?vue&type=template&id=18ac130f&"
import script from "./AssignmentHistoryGrid.vue?vue&type=script&lang=js&"
export * from "./AssignmentHistoryGrid.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentHistoryGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports